import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';

import React from 'react';
import Retail from '../../../assets/v2/kiosk/retail.svg';
import Hospitality from '../../../assets/v2/kiosk/hospitality.svg';
import Air from '../../../assets/v2/kiosk/air.svg';
import Banking from '../../../assets/v2/kiosk/banking.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Healthcare from '../../../assets/v2/kiosk/healthcare.svg';
import { navigate } from 'gatsby';
import KioskBg from '../../../assets/v2/png/kiosk_hero.jpg';
import KioskBgMobile from '../../../assets/v2/png/kiosk_mobile.jpg';
import { Title } from '../HomePage/HomepageSectionOne';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 8rem !important;
  padding-bottom: 5rem;
  background-image: linear-gradient(-180deg, #00000078, transparent),
    url(${KioskBg});
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    background-size: cover;
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    background-image: linear-gradient(-180deg, #00000078, transparent),
      url(${KioskBgMobile});
    background-size: cover;
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  color: #ffffff;
  font-size: 40px;
  @media (max-width: 1024px) {
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    margin-left: 0;
  }
`;

const GridRight = styled.div`
  grid-column: span 2;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 1;
  padding-left: 7rem;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-left: 0;
  }
`;

const HeroSubTitle = styled(SectionParent)`
  padding-top: 1.5rem;
  /* margin-left: 3rem;
  margin-right: 3rem; */
  padding: 0 14rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  /* text-shadow: 0px 1px #000000; */
  letter-spacing: normal;
  color: #ffffff;
  max-width: 70rem;
  width: 100%;
  text-align: center;
  @media (max-width: 1440px) and (min-width: 780px) {
    padding: 0rem 15rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    line-height: 1.14;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const HeroDomains = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 3rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (max-width: 768px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (max-width: 520px) {
    grid-gap: 1rem;
    grid-template-columns: repeat(6, 1fr);
  }
`;

const HeroDomainItem = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    display: grid;
    justify-items: center;
    grid-column: span 2;
  }
`;

const HeroDomainItemGap = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: unset;
    grid-column: span 1;
  }
`;

const HeroDomainItemImg = styled(LazyLoadImage)`
  width: 100%;
  @media (max-width: 520px) {
    width: 80%;
    justify-self: center;
  }
`;

const HeroDomainItemTitle = styled.div`
  text-align: center;
  margin-top: 1rem;
  color: #ffffff;
`;
const BlueButtonNew = styled(BlueButton)`
  box-shadow: 0 3px 13px 0 #2a2f46;
`;
export default class KioskHeader extends React.Component<any, any> {
  render() {
    return (
      <div>
        <SectionOne>
          <SectionItemContainer>
            <SectionOneTitle>
              The First Full-Stack Software Solution for the Kiosk Industry
            </SectionOneTitle>
            <HeroSubTitle style={{ paddingTop: '1rem' }}>
              Esper Manage provides an Android-based Kiosk management solution
              to dynamically lock down devices in Kiosk mode that defends
              against all security threats.
            </HeroSubTitle>
            <HeroDomains>
              <HeroDomainItem>
                <HeroDomainItemImg src={Retail} />
                <HeroDomainItemTitle>Retail</HeroDomainItemTitle>
              </HeroDomainItem>
              <HeroDomainItem>
                <HeroDomainItemImg src={Hospitality} />
                <HeroDomainItemTitle>Hospitality</HeroDomainItemTitle>
              </HeroDomainItem>
              <HeroDomainItem>
                <HeroDomainItemImg src={Air} />
                <HeroDomainItemTitle>Transportation</HeroDomainItemTitle>
              </HeroDomainItem>
              <HeroDomainItemGap />
              <HeroDomainItem>
                <HeroDomainItemImg src={Banking} />
                <HeroDomainItemTitle>Banking</HeroDomainItemTitle>
              </HeroDomainItem>
              <HeroDomainItem>
                <HeroDomainItemImg src={Healthcare} />
                <HeroDomainItemTitle>Healthcare</HeroDomainItemTitle>
              </HeroDomainItem>
            </HeroDomains>
            <BlueButtonWrapper>
              <BlueButtonNew
                id="kiosk__signup_for_free_2"
                onClick={() => navigate('/signup')}
              >
                Sign up for free
              </BlueButtonNew>
            </BlueButtonWrapper>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
